import styled from 'styled-components'

export const Container = styled.div`
  width: 450px;

  @media only screen and (max-width: 768px) {
    /* For everything smaller than 768px */
    width: 300px;
    .login-layout {
      padding: 15px !important;
    }

    .login-button {
      font-size: 12px;
    }
  }

  @media only screen and (max-width: 360px) {
    /* For everything less than 300px */
    width: 250px;

    .login-actions {
      flex-direction: column-reverse;
      align-items: center;

      .login-button {
        justify-content: center;
        width: 100%;
        margin-bottom: 12px;

        svg {
          height: 20px;
          width: 20px;
        }
      }
    }
  }
`

export const SloganHeader = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 100%;
  color: ${props => props.textColor || '#FFFFFF'};
  opacity: 1.00;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
`

export const SloganSubHeader = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 100%;
  color: #FFFFFF;
  opacity: 1.00;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
`



// WEBPACK FOOTER //
// ./src/routes/Login/styles.js